import { Dialog } from "@mui/material";
import React, { useState } from "react";
import ResultDetails from "./ResultDetails";
import StudentDetails from "./StudentDetails";
import TestDetails from "./TestDetails";
import ActionButtons from "./ActionButtons";
import DialogHeader from "./DialogHeader";
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg";
import { fetchAllPostPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../common/constant";
import {
  failureToast,
  successToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import { adjustmentFlagOptions } from "../utils";
import ALoader from "../../../../common/a-loader";
import ViewResultLogs from "./ViewResultLogs";

const AddEditResultsDialog = ({
  open,
  setOpen = () => {},
  resultInfo,
  fetchTestResults = () => {},
  setResultInfo,
  setSearchResultDialogOpen,
}) => {
  const [adjustmentFlag, setAdjustmentFlag] = useState(
    adjustmentFlagOptions?.find(
      (el) => el?.value === resultInfo?.adjustmentFlg,
    ),
  );

  const [resultForm, setResultForm] = useState(resultInfo);
  const [psid, setPsid] = useState(resultInfo?.psid);
  const [loading, setLoading] = useState(false);

  const [viewLogs, setViewLogs] = useState({ isOpen: false, id: "" });

  const handleReset = () => {
    setAdjustmentFlag(
      adjustmentFlagOptions?.find(
        (el) => el?.value === resultInfo?.adjustmentFlg,
      ),
    );
    setPsid(resultInfo?.psid);
    setResultForm(resultInfo);
  };

  const handleClose = () => {
    setOpen(false);
    setResultInfo({});
    setSearchResultDialogOpen(false);
  };

  const handleViewLogs = () => {
    setViewLogs({ isOpen: true, id: resultInfo.id });
  };

  const closeLogs = () => {
    setViewLogs({ isOpen: false, id: "" });
  };

  const forResultUpdate = resultInfo?.action === "edit"; //todo: roles configure

  const handleSave = async () => {
    const {
      aesTotalMarks,
      percentage,
      percentile,
      classStudying,
      stream,
      aesAllIndRank,
    } = resultForm;
    // if (
    //   (!aesTotalMarks,
    //   !percentage,
    //   !percentile,
    //   !classStudying,
    //   !stream,
    //   !aesAllIndRank)
    // ) {
    //   failureToast("Please enter all the fields.");
    //   return;
    // }

    try {
      setLoading(true);

      let url = endpoint?.studentResult?.updatePsidByRollNumberV1;
      let reqObj = {
        psid,
        rollNumber: resultInfo?.rollNo,
      };

      if (forResultUpdate) {
        url = endpoint?.studentResult?.updateAdjustmentFlag;
        const { externalSystemId, examDate, examTimeCode } = resultInfo;
        reqObj = {
          externalSystemId,
          examDate,
          examTimeCode,
          updatedAdjustmentFlag: adjustmentFlag?.value,
          // totalMarks: aesTotalMarks,
          // percentage: percentage,
          // percentile: percentile,
          // classes: classStudying,
          // stream: stream,
          // allIndiaRank: aesAllIndRank,
        };
      }

      const resp = await fetchAllPostPromisedData(url, reqObj, "put");

      if (resp?.code === 200) {
        handleClose();
        successToast("Updated successfully.");
        // successToast("Changes successfully synced with Superleap and Website.");
        fetchTestResults();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} fullWidth={false} maxWidth="md">
      <div className="p-3">
        {loading && <ALoader position="fixed" />}
        <div className="d-flex justify-content-between">
          <DialogHeader forResultUpdate={forResultUpdate} />
          <CrossIcon onClick={handleClose} />
        </div>

        {!forResultUpdate && (
          <StudentDetails
            psid={psid}
            setPsid={setPsid}
            resultInfo={resultInfo}
          />
        )}

        <TestDetails resultInfo={resultInfo} />

        <ResultDetails
          adjustmentFlag={adjustmentFlag}
          setAdjustmentFlag={setAdjustmentFlag}
          resultInfo={resultInfo}
          forResultUpdate={forResultUpdate}
          resultForm={resultForm}
          setResultForm={setResultForm}
        />

        <ActionButtons
          saveBtnTitle={
            forResultUpdate ? "Save Changes" : "Save and Add Result"
          }
          handleSave={handleSave}
          handleReset={handleReset}
          saveDisabled={!psid}
          handleViewLogs={handleViewLogs}
        />
      </div>

      {viewLogs.isOpen && (
        <ViewResultLogs closeLogs={closeLogs} viewLogs={viewLogs} />
      )}
    </Dialog>
  );
};

export default AddEditResultsDialog;
